@if (computedDuration(); as duration) {
  @let validYears = duration.years !== undefined && duration.years > 0;
  @let validMonths = duration.months !== undefined && duration.months > 0;

  @if (validYears || validMonths) {
    @if (validYears) {
      @if (duration.years === 1) {
        {{ duration.years }} {{ 'Jahr' | translate: "label-year" }}
      } @else {
        {{ duration.years }} {{ 'Jahre' | translate: "label-years" }}
      }
    }
    @if (validMonths) {
      @if (duration.months === 1) {
        {{ duration.months }} {{ 'Monat' | translate: "label-month" }}
      } @else {
        {{ duration.months }} {{ 'Monate' | translate: "label-months" }}
      }
    }
  }
  @if (!duration.days || duration.days === 0 ) {
     1 {{ 'Tag' | translate: "label-day" }}
  } @else {
    {{ duration.days < 0 ? 0 : duration.days + 1 }} {{ 'Tage' | translate: "label-days" }}
  }
}
